import type { ResolvedEditorState } from '@atlaskit/editor-common/collab';
import type { GetResolvedEditorStateReason } from '@atlaskit/editor-common/types/editor-actions';

import type { DocumentServiceInterface } from './interface-document-service';

// A Null object for the actual DocumentService class only for the experiment teammate presence  (ATLAS-53155)
export class NullDocumentService implements DocumentServiceInterface {
	setup = (): this => {
		return this;
	};

	updateDocument(): void {}

	onRestore(): void {}

	onStepsAdded(): void {}

	onStepRejectedError(): void {}

	send(): void {}

	sendStepsFromCurrentState(): void {}

	throttledCatchupv2(): void {}

	getCurrentState(): Promise<ResolvedEditorState> {
		return Promise.resolve({} as ResolvedEditorState);
	}

	getFinalAcknowledgedState(reason: GetResolvedEditorStateReason): Promise<ResolvedEditorState> {
		return Promise.resolve({} as ResolvedEditorState);
	}

	getIsNamespaceLocked() {
		return false;
	}

	getUnconfirmedSteps() {
		return undefined;
	}

	getUnconfirmedStepsOrigins() {
		return undefined;
	}

	getCurrentPmVersion() {
		return -1;
	}

	onErrorHandled = (): void => {};
}
